var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-list" },
    [
      _c(
        "el-card",
        [
          _c("z-search", {
            ref: "search",
            attrs: { configs: _vm.searchConfigs, init: _vm.getCustomerList },
            on: { "do-query": _vm.query },
            model: {
              value: _vm.searchData,
              callback: function ($$v) {
                _vm.searchData = $$v
              },
              expression: "searchData",
            },
          }),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt10" },
        [
          _c(
            "div",
            { staticClass: "mb-16" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "" },
                  on: {
                    click: function ($event) {
                      _vm.tagVisible = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customer::customer-list::标签规则")))]
              ),
            ],
            1
          ),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              data: _vm.lists,
              columns: _vm.columns,
              "auto-calc-table-height": "",
              pagination: _vm.pagination,
              "max-height": 550,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.handlePageChange,
              "selection-change": _vm.selectionChange,
            },
            scopedSlots: _vm._u([
              {
                key: "userEmail",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.userEmail))]),
                    row.userType
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              {
                                staticStyle: { "margin-right": "4px" },
                                attrs: { size: "mini" },
                              },
                              [_vm._v(" " + _vm._s(row.userType) + " ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "phone",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(_vm.$dataCheck(row.phone)) + " ")]
                },
              },
              {
                key: "customerLevelName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$dataCheck(row.customerLevelName)) + " "
                    ),
                  ]
                },
              },
              {
                key: "ordersCount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$dataCheck(row.ordersCount, "0")) + " "
                    ),
                  ]
                },
              },
              {
                key: "totalSpent",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$dataCheck(row.totalSpent, "0")) + " "
                    ),
                  ]
                },
              },
              {
                key: "refundOrderCount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$dataCheck(row.refundOrderCount, "0")) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "acceptsMarketing",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.acceptsMarketing === 1
                            ? _vm.editText.has_subscribe
                            : _vm.editText.no_subscribe
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "customer::customer-list::customer-detail",
                            expression:
                              "'customer::customer-list::customer-detail'",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(row)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.editText.detail) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("edit-dialog", {
        attrs: { row: _vm.editRow },
        on: { submit: _vm.getCustomerList },
        model: {
          value: _vm.visiable,
          callback: function ($$v) {
            _vm.visiable = $$v
          },
          expression: "visiable",
        },
      }),
      _c("Marking", {
        attrs: { selectList: _vm.selectList, tagList: _vm.tagList },
        on: { getData: _vm.getCustomerList },
        model: {
          value: _vm.markVisiable,
          callback: function ($$v) {
            _vm.markVisiable = $$v
          },
          expression: "markVisiable",
        },
      }),
      _c("TagRule", {
        model: {
          value: _vm.tagVisible,
          callback: function ($$v) {
            _vm.tagVisible = $$v
          },
          expression: "tagVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }